export type SidebarDetailsToolbarLayout = 'expanded' | 'standard' | 'tight';
export type CommentComposerToolbarDensity = 'tight' | 'compact';
export type SidebarMarkdownToolbarDensity = 'tight' | 'compact';

/** ~340px details pane nested edit composer. */
export const TIGHT_SIDEBAR_MARKDOWN_TOOLBAR_PX = 280;
/** ~400px details pane nested edit composer. */
export const COMPACT_SIDEBAR_MARKDOWN_TOOLBAR_PX = 380;

// Backward-compatible aliases for existing imports/usages.
export const TIGHT_COMMENT_COMPOSER_TOOLBAR_PX =
  TIGHT_SIDEBAR_MARKDOWN_TOOLBAR_PX;
export const COMPACT_COMMENT_COMPOSER_TOOLBAR_PX =
  COMPACT_SIDEBAR_MARKDOWN_TOOLBAR_PX;

export function getSidebarDetailsToolbarLayout(
  fullHeight: boolean,
  viewportWidth: number,
  fixedWidthDetailsToolbarColumn: boolean
): SidebarDetailsToolbarLayout {
  if (fullHeight) return 'expanded';
  if (viewportWidth <= 469) return 'expanded';
  if (viewportWidth >= 470 && viewportWidth <= 499) return 'tight';
  if (!fixedWidthDetailsToolbarColumn && viewportWidth < 951) return 'expanded';
  return 'standard';
}

export function sidebarMarkdownToolbarDensity(
  toolbarWidth: number
): SidebarMarkdownToolbarDensity | null {
  if (toolbarWidth <= 0) return null;
  if (toolbarWidth <= TIGHT_SIDEBAR_MARKDOWN_TOOLBAR_PX) return 'tight';
  if (toolbarWidth <= COMPACT_SIDEBAR_MARKDOWN_TOOLBAR_PX) return 'compact';
  return null;
}

export function commentComposerToolbarDensity(
  composerWidth: number
): CommentComposerToolbarDensity | null {
  return sidebarMarkdownToolbarDensity(composerWidth);
}
